import styled from '@emotion/styled'

export const StyledBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 64px;
  gap: 64px;
  width: 100%;
  min-height: 152px;
  background: #f1f8ff;
  border-radius: 8px;
`
